// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UuZj3","col":"styles_col__13c8X"};